module.exports = __webpack_public_path__ + "img/multiple.18835f7f.jpg";